import App from './App.vue'
import { mountVue } from '@/entries'
mountVue('#app', App, 'photogoodsIndex')
